import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BehaviorSubject } from 'rxjs';
import { SessionStorageService, SessionStorage } from 'ngx-webstorage';
import { UserInfo, UserRole } from 'app/_models';
import { RoutePath } from 'app/routing/routes';

export { UserInfo, UserRole };

@Injectable({
    providedIn: 'root',
})
export class UserService {
    @SessionStorage() private _User: UserInfo;

    UserSubject: BehaviorSubject<UserInfo>;

    get User(): UserInfo {
        return this._User;
    }

    set User(_ui: UserInfo) {
        this._User = _ui;
        this.UserSubject.next(_ui);
    }

    public get UserValue(): UserInfo {
        return this.UserSubject.value;
    }

    constructor(private storage: SessionStorageService, private router: Router, private sessionService: SessionStorageService) {
        this.UserSubject = new BehaviorSubject<UserInfo>(null);
        this.UserSubject.next(this._User);
    }

    // #region Clear User Service Call

    ClearUser() {
        this.User = null;
        this.sessionService.clear('_User');

        // Clear out all session specific settings.
        this.storage.clear('LastSearch');
        this.storage.clear('LastSearchParams');
    }

    // #endregion

    SetUser(user: UserInfo) {
        this.User = user;
    }

    // #region Set User Current Role Service Call

    SetUserCurrentRole(role: UserRole) {
        if (this.User.CurrentRole != null && role === this.User.CurrentRole) {
            return;
        }

        // To trigger proper session storage, we need to create a new object reference, rather than just updating our existing User object.
        const newUser: UserInfo = JSON.parse(JSON.stringify(this.User)) as UserInfo;

        // Update the current role field.
        newUser.CurrentRole = role;

        // Now, persist it to session storage and then broadcast it for listeners.
        this.User = newUser;

        // Go to the home screen for this role.
        this.router.navigate([RoutePath.Home]);
    }

    // #endregion

    // #region Update AuthToken Service Call

    UpdateAuthToken(AuthToken: any) {
        // If the authtoken has changed, update the user record.
        if (AuthToken !== this.User.authToken) {
            // To trigger proper session storage, we need to create a new object reference, rather than just updating our
            // existing User object.
            const newUser: UserInfo = JSON.parse(JSON.stringify(this.User)) as UserInfo;

            // Update the AuthToken field
            newUser.authToken = AuthToken;

            // Now, persist it to session storage and then broadcast it for listeners
            this.User = newUser;
        }
    }

    // #endregion
}
